export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YMptik8s6yLUrwB0lw.c7cc6b2a.woff2";